import { NgOptimizedImage } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-offering-card',
  imports: [RouterLink, NgOptimizedImage],
  templateUrl: './offering-card.component.html',
  styleUrl: './offering-card.component.scss',
})
export class OfferingCard {
  header = input.required<string>();
  fragment = input.required<string>();
  src = input.required<string>()
}
